import React, { useEffect, useState, useRef } from"react";
import { useNavigate } from"react-router-dom";
import { useTenant } from"../../Context/TenantContext";

const Timemanagequestionsmock = ({ mode = "learner" }) => {
 const [answer, setAnswer] = useState("");
 const [timeLeft, setTimeLeft] = useState(60); // 10 minutes total for 5 Qs
 const [isTimeUp, setIsTimeUp] = useState(false);
 const [currentIndex, setCurrentIndex] = useState(0);
 const [selectedQuestions, setSelectedQuestions] = useState([]);
 const [showFeedback, setShowFeedback] = useState(false);
 const [startTime, setStartTime] = useState(null);
 const [typingSpeed, setTypingSpeed] = useState(0);

 const textareaRef = useRef(null);
 const navigate = useNavigate();
 const { tenant } = useTenant();
 const isTenantMode = mode === "tenant" || !!tenant;
 // NextGen Builder / TSG Nexus embeds this page under
 // /nextgen-builder/mock-interview — back navigation must stay inside
 // /nextgen-builder/*, never the college/tenant /student/* routes.
 const isNextGenBuilderRoute = window.location.pathname.startsWith('/nextgen-builder');
 const backPath = isNextGenBuilderRoute
   ? "/nextgen-builder/mock-interview"
   : (isTenantMode ? "/student/mockinterviewhome" : "/mockinterviewhome");

 const readingParagraphs = [
 {
 id: 1,
 paragraph: `Technology is reshaping every facet of our lives, from how we communicate to how we work.In the digital age, information is more accessible than ever, and automation is transforming industries.Artificial intelligence is streamlining processes and opening doors to new opportunities.However, with rapid change comes new challenges that require careful thought.
Privacy is a major concern as digital footprints grow with every click and swipe.Our dependence on smart devices raises questions about autonomy and decision-making.Job displacement caused by machines has sparked debates on the future of employment.We must also consider the emotional toll of excessive screen time and digital interactions.
While we benefit from efficiency, we risk losing the human touch in our daily lives.Social connections are often replaced with notifications and quick replies.Balancing innovation with ethical responsibility is key to sustainable progress.Digital literacy is essential to navigate the complexities of modern life.Technology should be inclusive, not create wider gaps in accessibility.
Governments and corporations must establish transparent data policies.Tech creators hold immense power-they must wield it responsibly.Public discourse is needed to address ethical dilemmas in AI and surveillance.Education systems must evolve to prepare students for digital futures.
Critical thinking and creativity remain irreplaceable by any machine.We must harness technology to empower-not replace-human potential.The future lies in thoughtful integration of technology into our lives.`,
 question:
"What are your insights on the evolving role of technology in society?",
 },
 {
 id: 2,
 paragraph: `Climate change is not a distant threat-it is a reality impacting us now.
Extreme weather events are becoming more frequent and destructive globally.
Glaciers are melting, sea levels are rising, and ecosystems are suffering.
The planet is sending urgent signals, and our response must be swift and strategic.
Carbon emissions from fossil fuels remain a key contributor to global warming.
Sustainable energy sources like wind and solar are critical alternatives.
Individual actions-like reducing waste and using less plastic-make a difference.
The fashion and food industries also play roles in environmental impact.
Governments must enforce environmental regulations and fund green innovations.
International cooperation is vital, as climate change transcends borders.
Climate education empowers people to make informed decisions daily.
Youth-led movements are demanding accountability and policy reform.
Deforestation continues to deplete biodiversity and threaten indigenous lands.
Climate justice ensures vulnerable communities aren’t left behind.
Every policy, product, and practice should factor in sustainability.
Urban planning must include green spaces and efficient transport systems.
Sustainable agriculture helps feed populations while conserving nature.
It's not just about saving the planet-it’s about preserving life.
Time is of the essence, and apathy is our greatest enemy.
The future depends on the collective choices we make today.`,
 question:"What is your reflection on the urgency of climate action?",
 },
 {
 id: 3,
 paragraph: `Education has evolved far beyond traditional classrooms and blackboards.
Online platforms now provide global access to high-quality learning.
Anyone with an internet connection can master complex subjects for free or at low cost.
This shift has broken down many barriers of location and privilege.
However, digital education isn't a universal fix-it brings new challenges.
Many students still lack access to stable internet and digital devices.
Online learning demands high levels of self-discipline and time management.
Teachers must adapt by becoming facilitators, not just lecturers.
Digital literacy must be taught early, just like reading and math.
Collaboration tools have created virtual classrooms without borders.
However, the lack of in-person interaction can hinder emotional growth.
Hybrid models are emerging to blend the best of both worlds.
The future classroom could be a personalized, AI-assisted experience.
Gamification is making learning fun, interactive, and addictive-in a good way.
Assessment strategies must shift from memorization to critical application.
Educators must focus on nurturing curiosity and lifelong learning habits.
Parental support remains essential, especially for young learners.
Content must be inclusive and culturally relevant across platforms.
Technology should support, not replace, human connection in education.
A balanced, accessible, and inclusive system is the path forward.`,
 question:
"How do you view the transformation of education in the digital age?",
 },
 {
 id: 4,
 paragraph: `Urbanization continues to shape the 21st century at an unprecedented scale.
Cities offer economic opportunities, access to healthcare, and improved infrastructure.
However, urban growth also brings challenges such as congestion, pollution, and inequality.
Slums emerge when growth outpaces affordable housing development.
Public transport systems often buckle under the weight of increasing demand.
Smart city initiatives promise cleaner, more efficient urban environments.
These rely on data-driven solutions, sensors, and IoT for infrastructure management.
But technology alone can't solve deep-rooted social and economic problems.
Human-centered urban planning is necessary for truly livable cities.
Green spaces must be prioritized to improve mental health and reduce heat.
Inclusive housing ensures that cities remain accessible to all income levels.
Sustainable architecture reduces environmental impact and energy use.
Citizens must be involved in decisions that shape their communities.
Resilience planning is crucial to withstand disasters and climate events.
Urban food systems must be localized and sustainable for growing populations.
Cultural spaces and public art promote identity and community pride.
Digital connectivity should be a basic utility, like water or electricity.
Walkability and bike-friendly infrastructure improve public health.
Equity, not just efficiency, must guide urban policy decisions.
The future of cities depends on balance between growth and humanity.`,
 question:
"What is your interpretation of sustainable and human-centered urban development?",
 },
 {
 id: 5,
 paragraph: `Mental health is a cornerstone of overall well-being, yet often neglected.
Unlike physical injuries, mental struggles are frequently hidden and misunderstood.
Depression and anxiety affect millions globally, regardless of age or status.
The stigma around mental illness discourages people from seeking help.
Workplace stress, digital overload, and social isolation worsen mental health.
Campaigns have increased awareness, but access to care remains limited.
Therapy, medication, and support groups are vital, but not always affordable.
Mental health education should be integrated into schools and communities.
Emotional intelligence must be valued as much as cognitive intelligence.
Practicing mindfulness, exercise, and healthy routines supports mental wellness.
Family and peer support can be the first line of healing for many.
Digital tools like mental health apps can supplement but not replace therapy.
Burnout should be recognized as a serious health issue, not a badge of honor.
Creating safe, non-judgmental spaces is key to encouraging open dialogue.
Mental health is interconnected with physical, social, and spiritual health.
Government policies must treat mental healthcare as essential, not optional.
Companies should foster cultures of empathy and flexibility to reduce burnout.
Self-care is not selfish-it’s a form of resilience.
The more we talk, the more we normalize mental health.
Empathy and understanding can save lives.`,
 question:
"What is the importance of mental health awareness in today's society?",
 },
 {
 id: 6,
 paragraph: `Artificial intelligence (AI) is revolutionizing how we work, live, and think.
From virtual assistants to predictive analytics, AI is embedded in daily life.
In healthcare, AI helps detect diseases faster and more accurately than humans.
In business, it enhances customer service, automates tasks, and optimizes operations.
But the rise of AI also raises ethical and societal concerns.
Who is accountable when an AI-driven decision causes harm?
Bias in algorithms can reinforce discrimination and systemic inequalities.
Transparency in AI models is essential to build public trust.
Job automation threatens to displace workers in various industries.
However, AI can also create new roles and demand for digital skills.
Education systems must prepare students for an AI-integrated workforce.
Privacy is under threat as AI systems collect and analyze personal data.
Should AI be used in surveillance, law enforcement, or military decisions?
The race for AI dominance could deepen global inequalities.
AI should augment, not replace, human intelligence and creativity.
Regulatory frameworks must keep pace with technological advancements.
Ethical AI considers fairness, accountability, and human dignity.
Inclusive development ensures AI benefits all, not just the privileged.
AI can be a force for good if guided with wisdom and care.
The future depends not just on what AI can do, but what it should do.`,
 question:"How should society approach the ethical development of AI?",
 },
 {
 id: 7,
 paragraph: `Storytelling has been humanity’s most enduring method of sharing knowledge.
It existed long before writing, passed down through generations by word of mouth.
Stories help us make sense of the world, teach lessons, and preserve cultures.
In today’s world, storytelling has expanded through digital platforms and media.
Whether in books, podcasts, or social posts, stories shape perceptions.
Brands use storytelling to build identity and emotional connection with consumers.
Activists use it to raise awareness and mobilize communities.
Personal stories have the power to humanize abstract issues and statistics.
A compelling narrative can change hearts and influence public policy.
Stories offer comfort, wisdom, and perspective across time and cultures.
Empathy grows when we see life through someone else’s experiences.
Everyone has a story worth telling, regardless of fame or status.
Authenticity is the heart of effective storytelling.
Emotions-not just facts-make stories memorable and impactful.
Listening is as vital as telling in the storytelling process.
Digital tools allow anyone to become a global storyteller today.
Responsible storytelling means representing others truthfully and respectfully.
Storytelling empowers, connects, and transforms societies.
In a noisy world, stories help us feel seen, heard, and understood.
They remain one of the most powerful tools for change.`,
 question:
"What is the social value of storytelling in today's digital age?",
 },
 {
 id: 8,
 paragraph: `Discipline is often the silent engine behind long-term success.
While motivation is fleeting, discipline carries you through difficult days.
It means doing what needs to be done even when you don’t feel like it.
Successful athletes, artists, and entrepreneurs often credit discipline over talent.
It builds consistency, which compounds into excellence over time.
Discipline is not punishment; it's freedom through structure.
By setting boundaries, it allows space for creativity and focus.
It strengthens willpower like a muscle, growing with repeated use.
In a world of distractions, discipline is a rare and powerful trait.
It’s the difference between dreaming and achieving.
Time management, goal setting, and accountability are pillars of discipline.
Saying"no" to instant gratification leads to greater rewards later.
Small habits, repeated daily, form the foundation of disciplined living.
Self-discipline is deeply linked to self-respect and personal standards.
It also promotes mental clarity and emotional resilience.
Discipline isn't about perfection-it’s about showing up consistently.
Even failures can be part of a disciplined path if we learn from them.
When discipline is internalized, it becomes a form of self-leadership.
It empowers individuals to take control of their lives.
Discipline turns potential into progress.`,
 question:
"How does discipline influence personal achievement and growth?",
 },
 {
 id: 9,
 paragraph: `Leadership is more than giving orders-it’s about earning trust and inspiring others.
True leaders serve their team rather than demand obedience.
They lead by example, not by authority alone.
Emotional intelligence is a hallmark of strong leadership.
Great leaders are empathetic, self-aware, and resilient.
They listen actively and make space for diverse voices.
Leadership is tested most during adversity, not prosperity.
Integrity, humility, and vision define enduring leaders.
They accept responsibility when things go wrong and share credit when they go right.
Leadership requires the courage to make difficult, ethical decisions.
Good leaders develop other leaders, not followers.
They foster cultures of inclusion, growth, and accountability.
Communication, transparency, and consistency are key.
Leadership isn’t limited to managers-it exists at every level.
Anyone who takes initiative and uplifts others is a leader.
The best leaders are lifelong learners.
They adapt, evolve, and remain open to feedback.
In a world craving authenticity, true leadership stands out.
Society flourishes when led by those with heart, not ego.
Leadership is influence-use it wisely.`,
 question:"What qualities make someone a truly effective leader?",
 },
 {
 id: 10,
 paragraph: `Reading expands the mind and nourishes the soul.
It allows us to visit worlds we've never seen and perspectives we've never lived.
Books are time machines, transporting us across centuries and continents.
Fiction enhances empathy by letting us live multiple lives.
Non-fiction sharpens our understanding of history, science, and society.
Reading improves focus, vocabulary, and communication skills.
In a distracted world, reading trains the brain to think deeply.
Unlike scrolling, reading invites reflection, imagination, and patience.
Children exposed to reading early tend to perform better in school.
Reading as a habit fosters critical thinking and informed decision-making.
Libraries remain havens of knowledge and equality.
Reading reduces stress and boosts emotional intelligence.
It’s a portable, affordable way to invest in personal growth.
Reading challenges assumptions and strengthens analytical reasoning.
Book clubs foster community and shared learning.
Lifelong readers stay mentally agile into old age.
Informed citizens make stronger democracies.
Books empower us to think independently and dream boldly.
Reading is not just a skill-it’s a superpower.
To read is to grow.`,
 question:
"How does regular reading contribute to lifelong learning and personal development?",
 },
 {
 id: 11,
 paragraph: `Social media has changed how we connect, share, and communicate.
It gives a voice to the voiceless and spreads ideas quickly.
It enables activism, education, and global friendships.
But its rapid growth comes with unintended consequences.
Algorithms often show us what we already agree with, creating echo chambers.
Misinformation spreads faster than facts, impacting public opinion and safety.
Excessive use can lead to anxiety, loneliness, and low self-esteem.
The curated nature of posts can fuel unrealistic comparisons.
Digital literacy is essential to separate fact from fiction.
Social platforms must be held accountable for content moderation.
Users, too, must share responsibly and respectfully.
Social media can foster empathy-or polarization-depending on use.
Its power should be used for dialogue, not division.
Mindful usage can transform social media into a tool for growth.
Privacy must be protected, especially for vulnerable users.
Setting boundaries helps maintain mental wellness.
Educators should teach students how to navigate social media safely.
Social media is a mirror of society-we must decide what it reflects.
It’s a tool; its impact depends on how we wield it.
Awareness leads to more responsible digital behavior.`,
 question:
"What are the positive and negative effects of social media on individuals and society?",
 },
 {
 id: 12,
 paragraph: `Gratitude is more than saying “thank you”-it’s a mindset.
It shifts our focus from scarcity to abundance.
Grateful people tend to be happier and more resilient.
It strengthens relationships by making others feel appreciated.
Even during hardship, gratitude reveals hidden blessings.
Journaling what we’re thankful for enhances positivity.
Gratitude reduces stress, anxiety, and depression.
It improves sleep and boosts physical health.
Practicing gratitude nurtures humility and contentment.
It reminds us not to take the little things for granted.
Saying “thank you” can strengthen workplace culture.
Expressing gratitude daily fosters emotional intelligence.
Gratitude improves empathy and reduces aggression.
Communities rooted in gratitude are more generous and cohesive.
It helps people cope with trauma and loss.
Gratitude rewires the brain over time for optimism.
It deepens spiritual and interpersonal connections.
We often chase what we lack instead of valuing what we have.
Gratitude turns ordinary days into blessings.
Appreciation transforms lives-starting with our own.`,
 question:
"Why is cultivating gratitude important for personal well-being and relationships?",
 },
 {
 id: 13,
 paragraph: `Innovation drives progress in every field of human endeavor.
It’s about finding better ways to solve problems, large and small.
From fire to the internet, innovation has shaped civilization.
But not all innovation is positive or ethical.
Some technologies create new inequalities or environmental risks.
Ethical innovation asks: “Who benefits-and who might be harmed?”
Real innovation serves humanity, not just the market.
It must be sustainable, inclusive, and forward-thinking.
Diverse teams generate more creative, impactful solutions.
Innovation flourishes in environments that tolerate failure and reward curiosity.
Risk-taking and resilience are essential to breakthrough thinking.
True innovators learn constantly and challenge the status quo.
Innovation isn't always flashy-it can be quiet and life-changing.
It includes social, educational, and environmental improvements-not just tech.
Ethics and empathy must guide the innovation process.
Rapid progress demands slower, deeper reflection.
Not every idea should become a product.
Long-term thinking is key to responsible innovation.
We must innovate with both courage and conscience.
Innovation should uplift, not exploit.`,
 question:
"How can we ensure innovation benefits both present and future generations?",
 },
 {
 id: 14,
 paragraph: `Failure is often feared, but it’s a powerful teacher.
Every successful person has failed-often multiple times.
Failure builds resilience, humility, and insight.
It reveals weaknesses and areas for growth.
Avoiding failure means avoiding risk, and therefore growth.
Setbacks force us to reassess and adapt our approach.
They teach patience and perseverance.
Failure helps us separate ego from effort.
It's not the opposite of success-it’s part of it.
Reframing failure as feedback empowers us to keep going.
Many inventions were born from failed attempts.
Failing publicly builds emotional strength and vulnerability.
We should teach kids that failure is okay, even necessary.
Fear of failure can paralyze creativity and ambition.
Celebrating lessons from failure builds a growth mindset.
Businesses that embrace failure often innovate more.
It’s not failure that defines us-but how we respond.
Trying and failing is braver than never trying at all.
Fall seven times, stand up eight-that’s resilience.
Failure is a step forward, not a step back.`,
 question:
"How does failure contribute to growth and resilience in personal development?",
 },
 {
 id: 15,
 paragraph: `Empathy is the foundation of meaningful human connection.
It means truly understanding what someone else feels or faces.
Unlike sympathy, empathy involves emotional engagement, not just concern.
Empathetic people make better friends, leaders, and partners.
It helps us bridge cultural, political, and personal divides.
Empathy promotes kindness, patience, and non-judgmental listening.
In leadership, it builds trust, loyalty, and psychological safety.
It plays a critical role in conflict resolution and social justice.
Stories, art, and media can widen our empathetic perspective.
Empathy must be nurtured-it's not always automatic.
Listening deeply without trying to fix can be an empathetic act.
Children who learn empathy grow into more compassionate adults.
Empathy can combat bullying and discrimination in schools.
It creates inclusive environments where everyone feels seen.
In healthcare, empathy improves patient care and recovery.
Online interactions often lack empathy-leading to misunderstanding.
Digital empathy is becoming more important in today’s world.
The more empathy we practice, the more connected we become.
Empathy is not weakness-it’s emotional strength.
A more empathetic world is a more peaceful one.`,
 question:
"Why is empathy vital for building stronger communities and relationships?",
 },
 {
 id: 16,
 paragraph: `Procrastination affects nearly everyone at some point.
It often stems from fear, overwhelm, or lack of clarity.
Avoiding a task offers temporary relief but long-term stress.
Breaking work into smaller steps makes it less intimidating.
Setting specific, realistic goals increases focus and momentum.
Time-blocking and using timers can improve efficiency.
Perfectionism often fuels procrastination-done is better than perfect.
Self-awareness helps uncover why we delay certain tasks.
Distractions should be minimized during deep work sessions.
Accountability partners or public commitments can increase follow-through.
The hardest part is usually just getting started.
Celebrate small wins to build motivation.
Procrastination steals time and peace of mind.
Discipline transforms intention into completion.
Visualizing the rewards of finishing can spark action.
Learn to tolerate discomfort-it’s part of progress.
Forgive yourself and reset instead of spiraling into guilt.
Replacing “I have to” with “I choose to” empowers you.
Action leads to clarity-not the other way around.
Consistency beats cramming every time.`,
 question:
"What strategies can help individuals overcome procrastination and build consistency?",
 },
 {
 id: 17,
 paragraph: `Creativity is not limited to artists-everyone is born with creative potential.
It’s the ability to connect ideas in new and meaningful ways.
Creativity drives problem-solving, innovation, and self-expression.
It thrives in environments of psychological safety and curiosity.
Mistakes are often stepping stones to creative breakthroughs.
Routine can stifle creativity, while play often unlocks it.
Nature, travel, and reading can spark creative inspiration.
Diverse experiences fuel fresh perspectives and new ideas.
Creative thinking involves risk, uncertainty, and vulnerability.
It’s less about talent and more about mindset and practice.
Brainstorming, journaling, or doodling can jump-start the process.
Constraints often push us to think more creatively.
Collaboration enhances creativity through shared insight.
Taking breaks can lead to unexpected"aha" moments.
Creativity also requires discipline to turn ideas into reality.
It’s not about originality-it’s about authenticity and intention.
Creative people often ask “what if?” instead of “what is.”
Everyone has a unique voice worth expressing.
Creativity adds color, depth, and meaning to life.
Nurture it-and watch your world expand.`,
 question:
"How can creativity be cultivated and applied beyond traditional art forms?",
 },
 {
 id: 18,
 paragraph: `Time is the most valuable resource we have-once gone, it cannot be regained.
Yet we often spend it mindlessly, distracted or unfocused.
Time management begins with self-awareness and priorities.
Knowing what truly matters helps allocate time wisely.
Planning your day helps reduce stress and increase productivity.
The Eisenhower Matrix helps distinguish urgency from importance.
Saying “no” is a skill that protects your time and energy.
Digital distractions consume hours if left unchecked.
Batching similar tasks saves mental energy and time.
Breaks are essential to avoid burnout and maintain focus.
Time is not just for work-it’s for joy, rest, and connection.
Quality time with loved ones strengthens relationships.
Rushing through life robs us of presence and meaning.
Reflecting weekly helps assess how time was spent.
Time is not something we find-it’s something we make.
Discipline turns intentions into consistent actions.
Living intentionally means respecting your own time.
People respect those who respect their own schedule.
Use your time to build, create, and connect.
Invest time in what you want your life to become.`,
 question:
"Why is intentional time management important for a balanced life?",
 },
 {
 id: 19,
 paragraph: `Environmental sustainability is critical for the planet’s future.
Climate change threatens ecosystems, economies, and human health.
Deforestation, pollution, and overconsumption accelerate environmental decline.
Sustainability means meeting today’s needs without harming future generations.
Small actions, when multiplied, make a big difference.
Reducing plastic, conserving water, and recycling are everyday steps.
Green energy like solar and wind reduces carbon emissions.
Governments must support policies that protect natural resources.
Businesses should prioritize ethical sourcing and waste reduction.
Education is key to spreading environmental awareness.
Indigenous knowledge offers valuable insights into sustainable living.
Nature is not a resource-it’s a life support system.
We must shift from exploitation to stewardship.
Every species plays a role in Earth’s balance.
Sustainable agriculture feeds people while protecting biodiversity.
The youth are leading global climate movements with urgency.
Innovation can drive solutions-but must be rooted in ethics.
Environmental justice ensures vulnerable communities aren't left behind.
We don’t inherit the Earth-we borrow it from our children.
Protecting the planet is protecting ourselves.`,
 question:
"What actions can individuals and societies take to promote environmental sustainability?",
 },
 {
 id: 20,
 paragraph: `Kindness is a strength, not a weakness.It costs nothing but has lasting impact.A kind word can change someone’s entire day.
Kindness builds bridges where anger builds walls.It fosters trust, healing, and understanding.Random acts of kindness inspire hope and connection.Even small gestures matter-holding a door, offering a smile.
Kindness diffuses tension and reduces conflict.It improves relationships, both personal and professional.In leadership, kindness fosters loyalty and morale.
Kindness doesn’t mean being a pushover-it’s intentional and powerful.It requires empathy, patience, and active listening.Kind people often show higher emotional intelligence.
Kindness boosts well-being for both giver and receiver.It creates ripple effects-one act can inspire many more.In hard times, kindness becomes a source of strength.The world needs less judgment and more compassion.
Kindness should be taught, modeled, and celebrated.When in doubt, choose kindness-it’s always the right answer.In a divided world, kindness unites.`,
 question:"How can daily acts of kindness contribute to a better world?",
 },
 ];

 // On component mount, select 5 random unique questions
 useEffect(() => {
 const shuffled = readingParagraphs
 .map((value) => ({ value, sort: Math.random() }))
 .sort((a, b) => a.sort - b.sort)
 .map(({ value }) => value);

 setSelectedQuestions(shuffled.slice(0, 5));
 }, []);

 // Start timer for the entire quiz (2 minutes for all 5 questions)
 useEffect(() => {
 if (timeLeft <= 0) {
 setIsTimeUp(true);
 return;
 }
 if (!isTimeUp) {
 const timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
 return () => clearInterval(timer);
 }
 }, [timeLeft, isTimeUp]);

 // Reset answer & startTime on question change
 useEffect(() => {
 setAnswer("");
 setStartTime(Date.now());
 }, [currentIndex, selectedQuestions]);

 const formatTime = (seconds) => {
 const mins = String(Math.floor(seconds / 60)).padStart(2,"0");
 const secs = String(seconds % 60).padStart(2,"0");
 return `${mins}:${secs}`;
 };

 if (selectedQuestions.length === 0) {
 return <div className="text-white p-6">Loading questions...</div>;
 }

 const current = selectedQuestions[currentIndex];

 // Calculate typing speed on submit
 const handleSubmit = () => {
 if (!startTime) return;

 // Stop the timer as soon as the user submits
 setIsTimeUp(true);

 const now = Date.now();
 const timeInMinutes = (now - startTime) / 60000; // milliseconds to minutes
 const wordCount = answer.trim().split(/\s+/).filter(Boolean).length;
 const wpm = Math.round(wordCount / timeInMinutes) || 0;
 setTypingSpeed(wpm);
 setShowFeedback(true);
 };

 // Feedback message based on WPM (you can customize this)
 const getFeedbackMessage = (wpm) => {
 if (wpm >= 40) return"Great typing speed! Keep it up.";
 if (wpm >= 20)
 return"Good typing speed, but there's room for improvement.";
 return"Try to type a bit faster to improve your efficiency.";
 };

 return (
 <div className="flex bg-bgMain text-body min-h-screen relative overflow-hidden font-sans">
 <div className="absolute top-0 right-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl -mr-48 -mt-48"></div>
 
 {/* Sidebar */}
 <div className="w-72 bg-bgSection p-8 border-r border-accentGray/30 flex flex-col h-screen relative z-10 shadow-2xl">
 <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-primary via-secondary to-primary opacity-50"></div>
 <h2 className="text-2xl font-black bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent uppercase tracking-tighter mb-10">
 TheSkillGenie
 </h2>
 
 <div className="mb-10">
 <p className="text-[10px] font-black text-primary uppercase tracking-widest mb-3">Time Remaining</p>
 <p className="text-4xl font-mono text-primary drop-shadow-[0_0_10px_rgba(34,211,238,0.3)]">{formatTime(timeLeft)}</p>
 </div>

 <p className="text-[10px] font-black text-muted uppercase tracking-widest mb-4">Assessment Path</p>
 <div className="grid grid-cols-5 gap-2">
 {selectedQuestions.map((_, idx) => (
 <button
 key={idx}
 onClick={() => setCurrentIndex(idx)}
 className={`w-10 h-10 rounded-xl text-xs font-black transition-all duration-200 ${
 idx === currentIndex
 ?"bg-primary text-white shadow-lg shadow-primary/30 scale-110"
 :"bg-bgMain text-muted border border-accentGray/30 hover:border-primary/50"
 }`}
 >
 {idx + 1}
 </button>
 ))}
 </div>
 </div>

 {/* Main Content with conditional blur when modal open */}
 <div className={`${showFeedback ?"filter blur-md" :""} flex-1 p-8 md:p-12 overflow-y-auto relative z-10`}>
 <div className="max-w-4xl mx-auto">
 <div className="flex justify-between items-center mb-10">
 <button
 onClick={() => navigate(backPath)}
 className="flex items-center gap-2 text-muted hover:text-white transition-colors group font-black uppercase text-[10px] tracking-widest"
 >
 <span className="w-8 h-8 rounded-full bg-bgSection flex items-center justify-center group-hover:bg-primary/20 transition-all">←</span>
 Cancel Session
 </button>
 <div className="px-6 py-2 bg-primary/10 text-primary border border-primary/30 rounded-full text-[10px] font-black uppercase tracking-widest">
 Time Management • Round {currentIndex + 1}
 </div>
 </div>

 <div className="bg-bgSection p-8 md:p-12 rounded-[48px] shadow-2xl border border-accentGray/30 relative overflow-hidden">
 <div className="absolute -top-24 -right-24 w-64 h-64 bg-primary/10 rounded-full blur-3xl"></div>
 
 <div className="relative z-10">
 <div className="text-[10px] font-black text-primary mb-6 uppercase tracking-widest">
 Comprehension Context
 </div>
 
 <div className="bg-bgSoft p-8 rounded-3xl border border-accentGray/30 mb-10">
 <p className="text-xl font-medium text-body leading-relaxed tracking-tight">
 {current.paragraph}
 </p>
 </div>

 <div className="space-y-6">
 <h3 className="text-2xl font-black text-heading uppercase tracking-tighter border-l-4 border-secondary pl-4">
 {current.question}
 </h3>

 <textarea
 ref={textareaRef}
 value={answer}
 onChange={(e) => setAnswer(e.target.value)}
 disabled={isTimeUp || showFeedback}
 placeholder="Analyze the context and synthesize your response here..."
 className="w-full h-48 p-6 bg-bgMain text-body border border-accentGray/50 rounded-[32px] focus:border-primary outline-none transition-all text-lg leading-relaxed shadow-inner resize-none placeholder:text-muted/30"
 />

 {isTimeUp && (
 <div className="flex items-center gap-2 text-red-400 font-black uppercase text-[10px] tracking-widest bg-red-500/10 p-3 rounded-xl border border-red-500/20">
 <span className="animate-pulse">⏰</span> Session window closed. No further edits permitted.
 </div>
 )}
 </div>

 <div className="flex justify-between items-center mt-12 pt-10 border-t border-accentGray/30">
 <button
 onClick={() => setCurrentIndex((prev) => Math.max(prev - 1, 0))}
 disabled={currentIndex === 0 || showFeedback}
 className="text-muted font-black uppercase text-xs tracking-widest hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition-all"
 >
 ← Previous
 </button>

 {currentIndex < selectedQuestions.length - 1 && !showFeedback ? (
 <button
 onClick={() => {
 setIsTimeUp(false);
 setCurrentIndex((prev) => prev + 1);
 }}
 className="bg-primary text-white px-10 py-4 rounded-2xl font-black uppercase text-xs tracking-widest hover:bg-primary/90 hover:scale-105 active:scale-95 transition-all shadow-xl"
 >
 Next Case ->
 </button>
 ) : !showFeedback ? (
 <button
 onClick={handleSubmit}
 disabled={answer.trim().length === 0}
 className={`btn-primary-gradient px-12 py-4 rounded-2xl font-black uppercase text-xs tracking-widest shadow-xl transition-all ${
 answer.trim().length === 0 ?"opacity-50 cursor-not-allowed" :"hover:scale-105 active:scale-95"
 }`}
 >
 Submit Assessment
 </button>
 ) : null}
 </div>
 </div>
 </div>
 </div>
 </div>

 {/* Feedback Modal */}
 {showFeedback && (
 <div className="fixed inset-0 bg-bgMain/90 backdrop-blur-md flex items-center justify-center z-[100] p-4">
 <div className="bg-bgSection border-2 border-primary/30 rounded-[48px] shadow-[0_0_60px_rgba(79, 70, 229,0.3)] p-10 md:p-12 max-w-lg w-full text-center relative overflow-hidden animate-slideIn">
 <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-3xl"></div>
 
 <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-8 border border-primary/20">
 <span className="text-4xl">⚡</span>
 </div>

 <h2 className="text-3xl font-black text-white mb-2 uppercase tracking-tighter">Performance Result</h2>
 <p className="text-muted font-bold text-[10px] uppercase tracking-widest mb-8">Efficiency & Clarity Score</p>
 
 <div className="bg-bgSoft border border-accentGray/30 rounded-3xl p-8 mb-8 shadow-inner">
 <p className="text-muted font-black uppercase text-[10px] tracking-widest mb-2">Typing Speed</p>
 <div className="text-6xl font-black text-primary tracking-tighter">{typingSpeed} <span className="text-xl">WPM</span></div>
 </div>

 <div className="text-left mb-10 space-y-4">
 <p className="text-body font-bold text-lg leading-tight tracking-tight">
 {getFeedbackMessage(typingSpeed)}
 </p>
 <p className="text-muted text-sm leading-relaxed font-medium">
 High-speed synthesis is critical for professional agility. Continue refining your coherence and speed to master complex workflows.
 </p>
 </div>

 <button
 onClick={() => navigate(backPath)}
 className="w-full btn-primary-gradient py-4 rounded-2xl font-black uppercase text-xs tracking-widest shadow-xl hover:scale-105 active:scale-95 transition-all"
 >
 Return to Interface
 </button>
 </div>
 </div>
 )}
 </div>
 );
};

export default Timemanagequestionsmock;




